// This questionnaire is intentionally hard-coded to the
// `referral-network-application-v1.1` schema. Do not replace with
// a schema-driven renderer. Any backend questionnaire change requires
// a matching frontend PR here.
import React, { useMemo } from 'react';

import QuestionnaireShell, { TaskDefinition } from './QuestionnaireShell';
import AreasOfLaw from './tasks/AreasOfLaw';
import Confirmation from './tasks/Confirmation';
import Contact from './tasks/Contact';
import Disciplinary from './tasks/Disciplinary';
import Discount from './tasks/Discount';
import Exclusions from './tasks/Exclusions';
import FirmInfo from './tasks/FirmInfo';
import FixedRates from './tasks/FixedRates';
import HourlyExceptions from './tasks/HourlyExceptions';
import HourlyRate from './tasks/HourlyRate';
import Insurance from './tasks/Insurance';
import Languages from './tasks/Languages';
import Licenses from './tasks/Licenses';
import Name from './tasks/Name';
import PracticeStart from './tasks/PracticeStart';
import TaxId from './tasks/TaxId';
import Terms from './tasks/Terms';
import { SubmitPayload } from './types';

type Props = {
  onSubmit: (tasks: Record<string, any>) => void | Promise<void>;
};

const ReferralNetworkQuestionnaire = ({ onSubmit }: Props) => {
  const tasks = useMemo<ReadonlyArray<TaskDefinition>>(
    () => [
      Name,
      Contact,
      FirmInfo,
      PracticeStart,
      Licenses,
      AreasOfLaw,
      Exclusions,
      HourlyRate,
      HourlyExceptions,
      FixedRates,
      Disciplinary,
      Languages,
      Discount,
      Insurance,
      TaxId,
      Terms,
    ],
    [],
  );

  const handleSubmit = async (payload: SubmitPayload) => {
    await onSubmit(payload as unknown as Record<string, any>);
  };

  return (
    <QuestionnaireShell
      tasks={tasks}
      confirmation={Confirmation}
      onSubmit={handleSubmit}
      storageKey="referral-network-application-draft"
    />
  );
};

export default ReferralNetworkQuestionnaire;
